import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from '@mui/material';
import { accountContainerStyle, accountImageStyle } from './AccountPhoto.style';
import PersonIcon from '../../assets/images/person-black-icon.svg';
import { Img } from '../Primitive';
export const AccountPhoto = ({ imageUri, width, height, sx, handlePhotoClick, rectangular }) => {
    return (_jsx(Box, { onClick: handlePhotoClick, sx: accountImageStyle(imageUri, width, height, rectangular, handlePhotoClick), children: imageUri ? (_jsx(Img, { sx: sx, src: imageUri })) : (_jsx(Box, { sx: [accountContainerStyle(width, height), sx], children: _jsx(Img, { src: PersonIcon }) })) }));
};
//# sourceMappingURL=AccountPhoto.js.map